// SXAlertsContainer.tsx
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../app/store";
import { SXAlert } from "./SXAlert";
import { removeAlert } from "../../../features/ui/uiSlice";

export const SXAlertsContainer = () => {
  const dispatch = useDispatch();
  const alerts = useSelector((state: RootState) => state.uiSlice.alerts);

  if (alerts.length === 0) return null;

  return (
    // One fixed stack in the bottom-right corner. Each alert used to position itself with a
    // per-index offset of 5 % of the viewport height, which assumed they were all one line tall:
    // a calculation warning runs to several rows, so two of them overlapped. A flex column stacks
    // them by their actual height instead, and the max-width keeps a long message from spanning
    // the full width of a wide screen (it wraps onto more rows instead).
    <div
      className="no-print"
      style={{
        position: "fixed",
        bottom: "1rem",
        right: "1rem",
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        // flex-end + maxWidth (not width): a short alert still sizes to its content and hugs the
        // corner exactly as before, only a long one is capped and wraps.
        alignItems: "flex-end",
        gap: "0.5rem",
        maxWidth: "min(38rem, calc(100vw - 2rem))",
        // Tall stacks scroll rather than growing off the top of the screen.
        maxHeight: "calc(100vh - 2rem)",
        overflowY: "auto",
        // Do not intercept clicks over the page around the alerts; each alert re-enables them.
        pointerEvents: "none",
      }}
    >
      {alerts.map((a) => (
        <SXAlert
          key={a.id}
          id={a.id}
          status={a.status}
          text={a.text}
          context={a.context}
          varient={a.type}
          keep={a.keep}
          onClose={() => dispatch(removeAlert(a.id))}
        />
      ))}
    </div>
  );
};
